<!--
 * @Description: select 状态有 【可编辑，不可编辑，详情】
-->
<template>
  <CosViewSelect
    v-if="view && options"
    :fieldNames="fieldNames"
    v-bind="$attrs"
    :options="optionComputed"
    :value="value"
  />
  <a-radio-group
    v-else
    v-bind="$attrs"
    :fieldNames="fieldNames"
    :options="optionComputed"
    v-model:value="modelValue"
    style="width: 100%"
  >
    <slot></slot
  ></a-radio-group>
</template>
<script lang="ts" setup>
import { useVModel } from '@vueuse/core'
import { computed } from 'vue'
import CosViewSelect from '../CosView/select.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const props = defineProps({
  value: {
    type: [String, Number, Array]
  },
  view: {
    type: Boolean
  },
  options: {
    type: Array
  },
  fieldNames: {
    type: Object
  }
})
const optionComputed = computed(() => {
  if (props.options) {
    const label = props.fieldNames?.label || 'label'
    props.options?.forEach((item: any) => {
      if (item.lang) {
        item[label] = t(item.lang)
      }
    })
  }
  return props.options
})
const emit = defineEmits(['update:value'])
const modelValue = useVModel(props, 'value', emit)
</script>
